.freeTextCard {
  display: flex;
  align-items: center;
  text-decoration: none;

  .freeTextIcon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--primitives-colors-neutral-970);
  }

  .freeText {
    font: var(--font-body-md-medium);
    line-height: 25px;
    color: var(--primitives-colors-neutral-0);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    max-width: 220px;

    .phone &,
    .tablet & {
      max-width: 170px;
    }
  }
}
